import "./style.scss";

export default function Loader() {
  return (
    <div className="Loader"></div>
  );
}